import { action, observable } from 'mobx';
import forResponse from '../../utils/forResponse';

import http from '../../services/http/index';
import { FAN_ALIAS_FOR_ANCHOR } from '../../constants/apiUrls/apiUrls';


class AnchorDashboardStore {
  @observable fanAliases = null;

  getAliasForCurrentAnchorFans = (isAnchor, anchorId) => {
    if (!isAnchor) {
      return { error: 'error' };
    }
    const url = FAN_ALIAS_FOR_ANCHOR.replace('{currentUserId}', anchorId);

    return forResponse(http.get(url, { withCredentials: true }));
  };


  @action setFanAliases = async (isAnchor, anchorId) => {
    const { data, error } = await this.getAliasForCurrentAnchorFans(isAnchor, anchorId);
    if (!error) {
      this.fanAliases = data.data || {};
    }
  };
}

export default new AnchorDashboardStore();
